import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  card: theme => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: ${theme.spacing.xxs};

    hr {
      width: 100%;
      height: 1px;
      border: 0;
      background-color: ${theme.colors.neutral[100]};
    }
  `,

  cardHeader: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,

  nameWrapperTitle: theme => css`
    font-weight: ${theme.fontWeights.bold};
  `,

  specialtiesWrapper: theme => css`
    margin: -${theme.spacing.xs} 0 -${theme.spacing.xxs} 0;
    p {
      font-weight: ${theme.fontWeights.normal};
    }
    p:first-of-type {
      color: ${theme.colors.brand.primary[500]};
    }
  `,

  link: css`
    cursor: pointer;
    width: fit-content;
  `,

  cardFooter: theme => css`
    width: 100%;
    display: flex;
    justify-content: center;

    span {
      margin-top: 2px;
    }

    svg {
      width: ${theme.spacing.xs};
    }
  `,

  tagWrapper: css`
    display: flex;
    align-items: center;
  `,
})

export { useStyles }
